import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Navigate, Outlet, useParams, useLocation } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from '@application/store/useStore';
import LocalStorageService from '@application/common/local-storage-service';
import { VDKEventSlice } from '@application/features/vdkEvent/VDKEventSlice';
import dayjs from 'dayjs';
const EventRegistrationProtectedRoute = () => {
    const { e } = useParams();
    const location = useLocation();
    const dispatch = useAppDispatch();
    const { isEventValid, VDKEvent } = useAppSelector((state) => state.VDKEvent);
    const eventToken = LocalStorageService.getEventToken();
    // Check if event link is expired
    const isEventLinkExpired = (expiryDate) => {
        if (!expiryDate)
            return false;
        try {
            const expiry = dayjs(expiryDate).startOf('day');
            const today = dayjs().startOf('day');
            return today.isAfter(expiry);
        }
        catch (error) {
            return false;
        }
    };
    useEffect(() => {
        if (eventToken && !isEventValid) {
            dispatch(VDKEventSlice.actions.setEventValidation(true));
        }
    }, [eventToken, isEventValid, dispatch]);
    const isRegistrationPage = location.pathname === `/event-registration/${e}`;
    const isExpiredLinkPage = location.pathname === `/event-registration/${e}/expiredLink`;
    // If we're on the expired link page, check if the event is actually expired
    if (isExpiredLinkPage) {
        // If event is not expired, redirect back to main registration page
        if (VDKEvent &&
            VDKEvent.eventURLExpiryDate &&
            !isEventLinkExpired(VDKEvent.eventURLExpiryDate)) {
            return _jsx(Navigate, { to: `/event-registration/${e}`, replace: true });
        }
        // If event is expired or no expiry date, show the expired page
        return _jsx(Outlet, {});
    }
    // Check for expired link only if not already on expired page
    if (VDKEvent && VDKEvent.eventURLExpiryDate && isEventLinkExpired(VDKEvent.eventURLExpiryDate)) {
        return _jsx(Navigate, { to: `/event-registration/${e}/expiredLink`, replace: true });
    }
    if (isRegistrationPage) {
        return _jsx(Outlet, {});
    }
    const hasValidEventAccess = !!eventToken;
    if (!hasValidEventAccess) {
        return _jsx(Navigate, { to: `/event-registration/${e}`, replace: true });
    }
    return _jsx(Outlet, {});
};
export default EventRegistrationProtectedRoute;
